import { createContext } from 'react';

export const AdapterContext = createContext();
export const ArrayFieldApiContext = createContext();
export const ArrayFieldStateContext = createContext();
export const ArrayFieldItemApiContext = createContext();
export const ArrayFieldItemStateContext = createContext();
export const FormApiContext = createContext();
export const FormContext = createContext();
export const FormGroupContext = createContext();
export const FormStateContext = createContext();
export const MultistepApiContext = createContext();
export const MultistepStateContext = createContext();
export const MultistepStepContext = createContext({ isMultistepField: false });
